import React from 'react';
export function AboutSection() {
  return <section id="about" className="py-24 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-2">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-center" data-id="element-3">
        <div className="order-2 md:order-1" data-id="element-4">
          <div className="sticky top-20 md:static bg-white pb-6 md:pb-0 -mx-6 px-6 md:mx-0 md:px-0 z-10" data-id="element-5">
            <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-6">
              About
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-black mb-8 leading-tight" data-id="element-7">
              I help founders build the machine that builds the product.
            </h3>
          </div>
          <div className="space-y-6" data-id="element-8">
            <p className="text-lg text-gray-600 leading-relaxed font-light" data-id="element-9">
              I come from product and operations, not traditional consulting.
              Over the past 15+ years, I've worked as a founding and product
              leader at high-growth startups, helped scale complex products, and
              invested in early-stage companies as an angel.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed font-light" data-id="element-10">
              I've seen what happens when conviction outpaces coordination, and
              how quickly things move once execution stops bottlenecking at the
              founder.
            </p>
            <a href="https://www.linkedin.com/in/bgwynn/" target="_blank" rel="noopener noreferrer" className="inline-block text-sm font-medium uppercase tracking-widest border-b border-black pb-1 hover:text-gray-600 hover:border-gray-600 transition-colors mt-4" data-id="element-11">
              View background on LinkedIn →
            </a>
          </div>
        </div>
        <div className="order-1 md:order-2" data-id="element-12">
          <div className="aspect-[3/4] md:aspect-[4/5] w-full max-w-sm mx-auto md:ml-auto bg-gray-100 overflow-hidden" data-id="element-13">
            <img src="https://cdn.magicpatterns.com/uploads/oWzTYdTJ7LqLo7FXqaaDdw/0-16_copy.jpg" alt="Brittney Gwynn" className="w-full h-full object-cover object-[center_20%]" data-id="element-14" />
          </div>
        </div>
      </div>
    </section>;
}